import { lazy } from 'react';

import { type Route, type Routes } from 'react-resource-router';

import { componentWithSuspense } from '../../utils';

const CypherExplorerHome = lazy(
	() =>
		import(
			/* webpackChunkName: "@atlaskit-internal_dtac-cypher-explorer-home" */ '../../pages/graph-explorer/home/ObjectsVisualizer/cypher-explorer/home'
		),
);

const cypherExplorerRoutesObject: Record<string, Route> = {
	home: {
		name: 'cypher-explorer-home',
		path: '/cypher-explorer',
		exact: true,
		component: componentWithSuspense(CypherExplorerHome),
	},
} as const;

export const cypherExplorerRoutes: Routes = Object.values(cypherExplorerRoutesObject);
